/* @flow */

import * as types from './deviceActionTypes';

export function markAsTouchDevice() {
  return {
    type: types.MARK_AS_TOUCH_DEVICE,
  };
}
